module.exports = __webpack_public_path__ + "media/images/symbole-d'outil-rempli-de-filtre-f058619d11345d93eeddf2202d130029.svg";